function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #e3f5fe !important;\n      }\n\n      .cls-1 {\n        opacity: 0.3;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        filter: url(#filter);\n      }\n\n      .cls-4 {\n        font-size: 16px;\n        fill: #083d77 !important;\n        text-anchor: middle;\n        font-family: Montserrat;\n        font-weight: 400;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "filter",
  x: 0,
  y: 0,
  width: 84,
  height: 84,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  result: "offset",
  in: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 4.583
}), /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodOpacity: 0.18
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_1_kopia_2",
  "data-name": "Elipsa 1 kopia 2",
  className: "cls-1",
  cx: 83.25,
  cy: 88.125,
  r: 76.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_1_kopia_3",
  "data-name": "Elipsa 1 kopia 3",
  className: "cls-2",
  cx: 83.25,
  cy: 88.125,
  r: 55.84
});

var _ref5 = /*#__PURE__*/React.createElement("image", {
  id: "presentation-card-on-inclined-hand",
  x: 52,
  y: 58,
  width: 62,
  height: 62,
  xlinkHref: "data:img/png;base64,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"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_3",
  "data-name": "Elipsa 3",
  className: "cls-3",
  cx: 41.25,
  cy: 41.295,
  r: 21.25
});

var _ref7 = /*#__PURE__*/React.createElement("text", {
  id: "_4",
  "data-name": 4,
  className: "cls-4",
  x: 40.999,
  y: 46.501
}, "4");

var SvgKrok4 = function SvgKrok4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupa_12",
    "data-name": "Grupa 12",
    width: 159.75,
    height: 164.78,
    viewBox: "0 0 159.75 164.78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKrok4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/krok4.b3d2658f.svg";
export { ForwardRef as ReactComponent };